import React from 'react';
import http from '../httpService';
import {getLanguage, t} from 'react-switch-lang';
import {Tooltip} from 'antd';
import {externalizationStatuses} from '../../utils/externalizationFormOptions';

export function createExternalization(payload) {
  return http.post('/externalizations', payload);
}
export function updateExternalization(payload, id) {
  return http.put(`/externalizations/${id}`, payload);
}
export function deleteExternalization(id) {
  return http.delete(`/externalizations/${id}`);
}
export function requestForDeleteExternalization(id) {
  return http.put(`/externalizations/${id}/delete-request`);
}
export function rejectRequestForDeleteExternalization(id) {
  return http.put(`/externalizations/${id}/delete-request/reject`);
}
export function getAllExternalizations() {
  return http.get('/externalizations');
}

export function externalizationConfig() {
  return http.get('/externalization-form-configs');
}
export function getCyclesByExternalizationId(externalizationId) {
  return http.get(`/externalizations/${externalizationId}/cycles`)
}
export function getExternalizationByCycleId(id) {
  return http.get(`/externalizations/${id}`)
}

export function getOverallRiskAssessment(cycleId) {
  return http.get(`/externalizations/by-cycle/${cycleId}/overall-risk-assessment`)
}
export function getAllPotentialRisks(externalizationId) {
  return http.get(`/risks/by-externalization/${externalizationId}`)
}

export function getMonitoringFiles(externalizationsId, cycleId) {
  return http.get(`/externalizations/${externalizationsId}/monitoring/files?cycleId=${cycleId}`)
}
export function verifyForm(formType, cycleId, data) {
  return http.post(`/externalization-forms/${formType}/${cycleId}/verify`, data);
}
export const getExternalizationTableColumns = (
  user,
  history,
  onDelete,
  onEdit,
  allowDelete,
  allowEdit
) => [
  {
    key: 'id',
    dataIndex: 'id',
    title: t('externalization.externalizationId'),
    sorter: true,
  },
  {
    key: 'contractSubject',
    dataIndex: 'contractSubject',
    title: t('externalization.riskProponentForm.contractSubject'),
    sorter: true,
  },
  {
    key: getLanguage() === 'mne' ? 'departmentName' : 'departmentNameEN',
    dataIndex: (getLanguage() === 'mne' ? 'departmentName' : 'departmentNameEN'),
    title: t('externalization.departments'),
    render: (data) => {
      return <>{data ? data : '/' }</>;
    },
    sorter: true,
  },
  {
    key: 'serviceProviderName',
    dataIndex: 'serviceProviderName',
    title: t('externalization.riskProponentForm.serviceProvider'),
    sorter: true,
  },
  {
    key: 'overallRiskAssessmentLevel',
    dataIndex: 'overallRiskAssessmentLevel',
    title: t('externalization.riskProponentForm.totalRiskLevel'),
    render: (data) => {
      return data === 0
        ? <div style={{color: '#37C35C', fontWeight: 'bold'}}>{t('externalization.lowLevel')}</div>
        : data === 1
          ? <div style={{color: '#F59A1F', fontWeight: 'bold'}}>{t('externalization.mediumLevel')}</div>
          : data === 2
            ? <div style={{color: '#F5501F', fontWeight: 'bold'}}>{t('externalization.highLevel')}</div>
            : '/'
    },
  },
  {
    key: 'critical',
    dataIndex: 'critical',
    title: t('externalization.riskProponentForm.criticalExternalization'),
    render: (data) => {
      return <>{ data === true ? t('common.yes') : data === false ? t('common.no') : '/'}</>
    },
  },
  {
    key: 'status',
    title: t('externalization.externalizationStatus.externalizationStatus'),
    render: (record) => {
      const statusValue = record?.status;
      const cycleNumber = record?.currentCycleNumber;
      const statusItem = externalizationStatuses.find(item => item?.value === statusValue);
      const statusLabel = statusItem ? statusItem?.label : '/';
      return (
        <>
          {(statusValue === 'REASSESSMENT_IN_PROGRESS' || statusValue === 'REASSESSMENT_COMPLETED') ? (
            <>
              {cycleNumber ? `${cycleNumber}. ` : ''}
              {statusLabel}
            </>
          ) : (
            <>{statusLabel}</>
          )}
        </>
      );
    },
  },
  {
    key: 'buttons',
    dataIndex: 'buttons',
    title: '',
    render: (record, item) => {
      const canEdit = allowEdit || (user?.id === item?.proposalFormUserInChargeId) || (user?.id === item?.proposalFormUserInChargeDeputyId);
      return (
        <div style={{display: 'flex', gap: '20px', float: 'right'}}>
          {canEdit && <Tooltip title={t('common.edit')}>
            <img
              onClick={(e) => {
                onEdit(item);
                e.stopPropagation();
              }}
              style={{cursor: 'pointer'}}
              src={process.env.PUBLIC_URL + '/images/blueEdit.svg'}
            />
          </Tooltip>}
          {allowDelete && <Tooltip title={t('common.delete')}>
            <img
              onClick={async (e) => {
                e.stopPropagation();
                await onDelete(item);
              }}
              style={{cursor: 'pointer'}}
              src={process.env.PUBLIC_URL + '/images/delete.svg'}
            />
          </Tooltip>}
        </div>
      );
    },
  },
]